<template>
  <div class="row">
    <div class="col-md-4">
      <div class="card bg-danger">
        <div class="card-body">
          <div class="px-3 py-3">
            <div class="row text-white">
              <div class="col-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 480 480"
                  wtx-context="DC3A94BF-67EF-4841-BE05-57DBCA1127B9"
                  class
                >
                  <g>
                    <path
                      d="m445.65625 2.34375c-1.496094-1.503906-3.535156-2.34375-5.65625-2.34375h-88c-4.414062 0-8 3.574219-8 8 0 12.304688 4.6875 23.496094 12.320312 32h-108.320312c-13.230469 0-24 10.769531-24 24s10.769531 24 24 24h73.472656c-.898437 2.511719-1.472656 5.183594-1.472656 8 0 6.167969 2.40625 11.742188 6.238281 16-3.839843 4.257812-6.238281 9.832031-6.238281 16s2.40625 11.742188 6.238281 16c-3.839843 4.257812-6.238281 9.832031-6.238281 16 0 13.230469 10.769531 24 24 24h136v-16h-136c-4.40625 0-8-3.585938-8-8s3.59375-8 8-8h64v-16h-64c-4.40625 0-8-3.585938-8-8s3.59375-8 8-8h64v-16h-64c-4.40625 0-8-3.585938-8-8s3.59375-8 8-8h64v-16h-160c-4.40625 0-8-3.585938-8-8s3.59375-8 8-8h184v-16h-40c-14.878906 0-27.425781-10.207031-30.992188-24h75.671876l13.65625 13.65625c1.503906 1.503906 3.542968 2.34375 5.664062 2.34375h24v-16h-20.6875zm0 0"
                      data-original="#000000"
                      class="active-path"
                      data-old_color="#F7F6F6"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="m272 176c0-28.519531-24.230469-66.703125-25.265625-68.3125-2.941406-4.589844-10.527344-4.589844-13.476563 0-1.027343 1.609375-25.257812 39.792969-25.257812 68.3125 0 26.535156 10.769531 40 32 40s32-13.464844 32-40zm-48 0c0-15.3125 9.296875-35.449219 16-47.976562 6.703125 12.527343 16 32.664062 16 47.976562 0 24-8.871094 24-16 24s-16 0-16-24zm0 0"
                      data-original="#000000"
                      class="active-path"
                      data-old_color="#F7F6F6"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="m472 336h-168v-56c0-22.054688-17.945312-40-40-40h-224c-22.054688 0-40 17.945312-40 40v160c0 22.054688 17.945312 40 40 40h224c22.054688 0 40-17.945312 40-40v-56h168c4.414062 0 8-3.574219 8-8v-32c0-4.425781-3.585938-8-8-8zm-312 56h47.34375c-9.816406 16.902344-27.105469 28.902344-47.34375 31.449219zm56-32c0 5.535156-.777344 10.871094-2.105469 16h-53.894531v-32h53.894531c1.328125 5.128906 2.105469 10.464844 2.105469 16zm-56-32v-31.449219c20.230469 2.546875 37.527344 14.546875 47.34375 31.449219zm-16 96h-128v-128h128zm120 40h-224c-13.230469 0-24-10.769531-24-24h136c44.113281 0 80-35.886719 80-80s-35.886719-80-80-80h-136c0-13.230469 10.769531-24 24-24h224c13.230469 0 24 10.769531 24 24v40.808594c-18.230469 3.71875-32 19.871094-32 39.191406s13.769531 35.472656 32 39.191406v40.808594c0 13.230469-10.769531 24-24 24zm24-126.527344v45.046875c-9.289062-3.3125-16-12.113281-16-22.527343 0-10.417969 6.710938-19.207032 16-22.519532zm176 30.527344h-160v-16h160zm0 0"
                      data-original="#000000"
                      class="active-path"
                      data-old_color="#F7F6F6"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="m72 320h16v16h-16zm0 0"
                      data-original="#000000"
                      class="active-path"
                      data-old_color="#F7F6F6"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="m72 352h16v16h-16zm0 0"
                      data-original="#000000"
                      class="active-path"
                      data-old_color="#F7F6F6"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="m72 384h16v16h-16zm0 0"
                      data-original="#000000"
                      class="active-path"
                      data-old_color="#F7F6F6"
                      fill="#FFFFFF"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="col-8 text-right pl-0">
                <h4 class="text-white mb-2">{{ $t("labels.bloodGroup") }}</h4>
                <h4 class="pt-1 m-0 text-white">{{ patient.bloodGroup }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card bg-info">
        <div class="card-body">
          <div class="px-3 py-3">
            <div class="row text-white">
              <div class="col-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                  wtx-context="DFC63F71-AF2E-47F2-8F98-F1C50956677E"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M315.429,146.286h-4.937c8.722-9.719,14.08-22.51,14.08-36.571c0-30.254-24.603-54.857-54.857-54.857    s-54.857,24.603-54.857,54.857c0,14.062,5.358,26.853,14.08,36.571H224c-25.207,0-45.714,20.507-45.714,45.714v128    c0,5.047,4.087,9.143,9.143,9.143h27.429v173.714c0,5.047,4.087,9.143,9.143,9.143h45.714h9.143    c25.207,0,45.714-20.507,45.714-45.714V329.143H352c5.056,0,9.143-4.096,9.143-9.143V192    C361.143,166.793,340.635,146.286,315.429,146.286z M269.714,73.143c20.169,0,36.571,16.402,36.571,36.571    s-16.402,36.571-36.571,36.571s-36.571-16.402-36.571-36.571S249.545,73.143,269.714,73.143z M275.319,164.571l-5.605,16.805    l-5.605-16.805H275.319z M342.857,310.857h-18.286V192h-18.286v274.286c0,15.122-12.306,27.429-27.429,27.429V329.143h-18.286    v164.571h-27.429V192h-18.286v118.857h-18.286V192c0-15.122,12.306-27.429,27.429-27.429h20.846l16.201,48.603    c1.243,3.739,4.727,6.254,8.667,6.254s7.424-2.514,8.667-6.254l16.201-48.603h20.846c15.122,0,27.429,12.306,27.429,27.429    V310.857z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M150.857,0H59.429c-5.056,0-9.143,4.096-9.143,9.143v493.714c0,5.047,4.087,9.143,9.143,9.143h91.429    c5.056,0,9.143-4.096,9.143-9.143V9.143C160,4.096,155.913,0,150.857,0z M141.714,54.857h-18.286v18.286h18.286v36.571h-36.571    V128h36.571v36.571h-18.286v18.286h18.286v36.571h-36.571v18.286h36.571v36.571h-18.286v18.286h18.286v36.571h-36.571v18.286    h36.571V384h-18.286v18.286h18.286v36.571h-36.571v18.286h36.571v36.571H68.571V18.286h73.143V54.857z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="178.286"
                          y="18.286"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="214.857"
                          y="18.286"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="251.429"
                          y="18.286"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="288"
                          y="18.286"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="324.571"
                          y="18.286"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="361.143"
                          y="18.286"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="333.714"
                          y="493.714"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="370.286"
                          y="493.714"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="406.857"
                          y="493.714"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                    <g>
                      <g>
                        <rect
                          x="443.429"
                          y="493.714"
                          width="18.286"
                          height="18.286"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#000000"
                          fill="#FFFFFF"
                        ></rect>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="col-8 text-right pl-0">
                <h4 class="text-white mb-2">{{ $t("labels.heightCm") }}</h4>
                <h4 class="text-white mb-2">{{ patient.heightCm }} cm</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card bg-warning">
        <div class="card-body">
          <div class="px-3 py-3">
            <div class="row text-white">
              <div class="col-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 64 64"
                  wtx-context="7E28EC3E-DFF1-49C6-BCDF-EC5ABA086EAB"
                >
                  <g>
                    <g id="outline">
                      <path
                        d="M59,21a5.006,5.006,0,0,0-5-5H50.958C50.3,8.193,42.051,2,32,2S13.7,8.193,13.042,16H10a5.006,5.006,0,0,0-5,5V51A11.013,11.013,0,0,0,16,62H48A11.013,11.013,0,0,0,59,51ZM57,51a9.01,9.01,0,0,1-9,9H16a9.01,9.01,0,0,1-9-9V21a3,3,0,0,1,3-3h4a1,1,0,0,0,1-1C15,9.832,22.626,4,32,4S49,9.832,49,17a1,1,0,0,0,1,1h4a3,3,0,0,1,3,3Z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        d="M28.964,27.773h.012a20.434,20.434,0,0,0,6.048,0h.012C41.856,26.741,47,22.3,47,17a9.719,9.719,0,0,0-4.268-7.669c-.01-.012-.014-.027-.025-.038a1,1,0,0,0-.335-.221A18.124,18.124,0,0,0,32,6c-8.271,0-15,4.935-15,11C17,22.3,22.144,26.741,28.964,27.773ZM33.82,25.9a18.447,18.447,0,0,1-3.64,0L30,25.883a2,2,0,0,1,3.992,0ZM21,16H19.085a8.131,8.131,0,0,1,3.394-5.107l1.814,1.814a1,1,0,0,0,1.414-1.414L24.22,9.806A16.7,16.7,0,0,1,31,8.035V10a1,1,0,0,0,2,0V8.035a16.382,16.382,0,0,1,7.426,2.124l-1.133,1.134a1,1,0,1,0,1.414,1.414l1.377-1.377A7.855,7.855,0,0,1,44.915,16H43a1,1,0,0,0,0,2h1.915c-.573,3.565-4.162,6.507-8.958,7.571A3.986,3.986,0,0,0,33,22.142V14a1,1,0,0,0-2,0v8.142a3.986,3.986,0,0,0-2.957,3.429c-4.8-1.064-8.385-4.006-8.958-7.571H21a1,1,0,0,0,0-2Z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#FFFFFF"
                      ></path>
                      <rect
                        x="45"
                        y="52"
                        width="2"
                        height="2"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#FFFFFF"
                      ></rect>
                      <rect
                        x="47"
                        y="48"
                        width="2"
                        height="2"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#FFFFFF"
                      ></rect>
                      <rect
                        x="15"
                        y="30"
                        width="2"
                        height="2"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#FFFFFF"
                      ></rect>
                      <path
                        d="M52,22H49a1,1,0,0,0-.933.639C46.442,26.835,39.535,30,32,30s-14.442-3.165-16.067-7.361A1,1,0,0,0,15,22H12a1,1,0,0,0-1,1V51a7.008,7.008,0,0,0,7,7h6a7.008,7.008,0,0,0,7-7V49h2v2a7.008,7.008,0,0,0,7,7h6a7.008,7.008,0,0,0,7-7V23A1,1,0,0,0,52,22ZM51,51a5.006,5.006,0,0,1-5,5H40a5.006,5.006,0,0,1-5-5V48a1,1,0,0,0-1-1H30a1,1,0,0,0-1,1v3a5.006,5.006,0,0,1-5,5H18a5.006,5.006,0,0,1-5-5V24h1.349c2.308,4.673,9.563,8,17.651,8s15.343-3.327,17.651-8H51Z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#FFFFFF"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="col-8 text-right pl-0">
                <h4 class="text-white">{{ $t("labels.weightKg") }}</h4>
                <h4 class="text-white">{{ patient.weightKg }} kg</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ["patient"],
}
</script>